module.exports = {
  name: "Majji kishore",
  greeting: "Hi there 👋",
  greetingDescription:
    "I am fullstack web developer , currently working at Navgurukul as a backend-intern",
  githubUrl: "https://github.com/majjikishore007",
  linkedinUrl: "http://linkedin.com/in/majji-kishore-ab18a9195",
  gmailUrl: "https://majjikishore031@gmail.com",
  twitterUrl: "https://twitter.com/MajjiKishore1",
  discordUrl: "https://discord.com/users/kishoremajji007#0165/",
  cvLink:
    "https://docs.google.com/document/d/1E1234561NMyQA67890ygda7abcdefghijs1jBp7HFI0/",
};
